import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Store, Navigation, ShoppingBag, ExternalLink, CalendarX } from "lucide-react";

const PIN = L.divIcon({
  className: "",
  html: `<svg width="30" height="40" viewBox="0 0 30 40"><path d="M15 0C6.7 0 0 6.7 0 15c0 10.5 15 25 15 25s15-14.5 15-25C30 6.7 23.3 0 15 0z" fill="#F5551E"/><circle cx="15" cy="15" r="6" fill="#fff"/></svg>`,
  iconSize: [30, 40], iconAnchor: [15, 40],
});

const hasStore = (d) => (d.business_types || []).includes("storefront") && d.store_address;

export const StoreMap = ({ data }) => {
  if (!hasStore(data)) return null;
  const directions = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(data.store_address)}`;
  const pos = data.store_lat != null && data.store_lng != null ? [data.store_lat, data.store_lng] : null;
  return (
    <div className="bg-white rounded-2xl border border-slate-200/80 overflow-hidden" data-testid="store-map-card">
      {pos && (
        <div className="h-48 relative z-0" data-testid="store-map">
          <MapContainer key={pos.join(",")} center={pos} zoom={15} scrollWheelZoom={false} className="h-full w-full">
            <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={pos} icon={PIN} />
          </MapContainer>
        </div>
      )}
      <div className="p-5">
        <h3 className="text-sm font-bold text-[#12234A] uppercase tracking-wide flex items-center gap-2"><Store size={15} className="text-[#F5551E]" /> Visit our store</h3>
        <p className="text-sm text-slate-600 mt-2" data-testid="store-address">{data.store_address}</p>
        <a href={directions} target="_blank" rel="noopener noreferrer" data-testid="store-directions-btn"
          className="mt-3 inline-flex items-center gap-1.5 h-9 px-4 rounded-xl bg-[#12234A] hover:bg-[#0E1B38] text-white text-sm font-semibold transition-colors">
          <Navigation size={14} /> Get directions
        </a>
      </div>
    </div>
  );
};

export const OpenBadge = ({ open, closure, testid = "open-now-badge" }) => {
  if (open == null) return null;
  if (closure) return <span data-testid={testid} title={closure.note || "Special closure"} className="inline-flex items-center gap-1.5 bg-red-50 text-red-700 border border-red-200 text-xs font-semibold px-2.5 py-1 rounded-full"><CalendarX size={12} /> Closed today{closure.note ? ` · ${closure.note}` : ""}</span>;
  return open
    ? <span data-testid={testid} className="inline-flex items-center gap-1.5 bg-emerald-50 text-emerald-700 border border-emerald-200 text-xs font-semibold px-2.5 py-1 rounded-full"><span className="h-1.5 w-1.5 rounded-full bg-emerald-500" /> Open now</span>
    : <span data-testid={testid} className="inline-flex items-center gap-1.5 bg-slate-100 text-slate-500 border border-slate-200 text-xs font-semibold px-2.5 py-1 rounded-full"><span className="h-1.5 w-1.5 rounded-full bg-slate-400" /> Closed</span>;
};

export const ShopOnline = ({ data }) => {
  if (!(data.business_types || []).includes("online") || !data.shop_url) return null;
  return (
    <a href={data.shop_url} target="_blank" rel="noopener noreferrer" data-testid="shop-online-btn"
      className="mt-4 inline-flex items-center gap-2 h-10 px-5 rounded-xl bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold shadow-sm transition-colors">
      <ShoppingBag size={16} /> Shop online <ExternalLink size={13} className="opacity-80" />
    </a>
  );
};
